import React from "react";
import { Field } from "formik";
import Loading from "../utils/loader";
const CareersRegisterRadio = (props) => {
  return (
    <>{props.radioBtn?.length > 0 && <>
      <div className="careers_register_passport">
        {props.tertiaryChecboxLoading ?
          <Loading /> :
          <>
            <p>{props.placeholder ?? props.tertiaryChecboxData?.text}</p>
            <div className="careers_register_interested_card">
              {props.radioBtn?.map((obj, index) => {
                return (
                  <span key={index} className="careers_register_custom_checkbox">
                    <Field
                      type="radio"
                      name={props.name}
                      id={`crc_${obj.id}-${props.tertiaryChecboxData?.text}`}
                      value={props.values?.[props?.name] ? props.values?.[props?.name] : {}}
                      checked={obj.selected || props.values?.[props?.name]?.[0]?.id == obj?.id}
                      onChange={(item, id) => {
                        props.handleRadioChange(item, obj.id);
                      }}
                    />
                    <label className="radio_label" htmlFor={`crc_${obj.id}-${props.tertiaryChecboxData?.text}`}>{obj.value}</label>
                  </span>
                );
              })}
            </div>
          </>}
      </div>
    </>}
    </>
  );
};

export default CareersRegisterRadio;
